import { darken, rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { FatalAttraction } from '@vpr/tracking';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { Button } from '@vimeo/iris/components';

const custom = {
  formats: {
    primary: theme.colors.blue['600'],
  },
};

const BlueBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.blue['500']};
  padding: ${rem('8px')} 0;
`;

const UpgradeText = styled.div`
  color: white;
  font-size: ${rem('14px')};
  margin-right: ${rem('16px')};
`;

interface UpgradeBannerProps {
  text: string;
  linkText: string;
  url?: string;
}

export default function UpgradeBanner({ text, linkText, url = '/upgrade' }: UpgradeBannerProps) {
  return (
    <BlueBanner>
      <UpgradeText>{text}</UpgradeText>
      <a target="_blank" href={url}>
        <Button
          size="sm"
          format="primary"
          element="span"
          theme={custom}
          onClick={() =>
            FatalAttraction.trackClick({
              container: 'album_player',
              component: 'upgrade_link',
              keyword: 'preview_upsell_banner',
            })
          }
        >
          {linkText}
        </Button>
      </a>
    </BlueBanner>
  );
}
